<template>
  <div id="main" class="container">
    <alert-area class="my-3" :alerts="alerts"></alert-area>
    <div class="my-3">
      <button class="btn btn-warning" @click="deleteStamp()">
        <font-awesome-icon icon="trash" /> DELETE
      </button>
    </div>
    <div class="my-3">
      <button class="btn btn-sm" :class="filterBtnClass"
        data-toggle="collapse" data-target="#filter">
        <font-awesome-icon icon="filter" /> Filter
      </button>
    </div>
    <div id="filter" class="my-3 collapse">
      <div class="row">
        <div class="form-group col">
          <label for="date-from"> From: </label>
          <input type="date" class="form-control" id="date-from" v-model="stampFilters.dateFrom">
        </div>
        <div class="form-group col">
          <label for="date-to"> To: </label>
          <input type="date" class="form-control" id="date-to" v-model="stampFilters.dateTo">
        </div>
      </div>
      <div>
        <button class="btn btn-sm btn-outline-primary" @click="resetFilter">
          <font-awesome-icon icon="eraser" /> Reset filter
        </button>
      </div>
    </div>

    <hr>

    <div id="timerecords" class="my-3">
      <h3 class="mb-3">Records</h3>
      <ul class="list-group">
        <li class="list-group-item d-flex p-0"
          v-for="s in stampsSliced"
          :key="s.time">
          <div class="py-3 px-4 mr-auto">{{ s.time | timestamp }}</div>
          <div class="py-3 px-3 text-secondary">
            <font-awesome-icon class="pointer" icon="check-circle" size="lg"
                v-if="s.isMarked" @click="toggleMark(s)" />
            <font-awesome-icon class="pointer" :icon="['far', 'circle']" size="lg"
                v-if="!s.isMarked" @click="toggleMark(s)" />
          </div>
        </li>
        <li id="read-more" class="list-group-item text-primary"
          style="cursor: pointer;"
          v-if="stampsView.length > viewLimit"
          @click="readMore()">
            <infinite-loading v-if="preferences.autoReadMore" @infinite="infiniteHandler"></infinite-loading>
            More records...
          </li>
      </ul>
      <div class="alert alert-secondary text-muted" v-if="stampsView.length == 0">
        No Records
      </div>
    </div>

  </div>
</template>

<script>
import AlertArea from '../components/AlertArea.vue'
import alerts from '../resources/alerts.js'
import common from '../resources/common.js'
import { recordComponentBase as recordMixin } from '../resources/mixins.js'

export default {
  name: 'Delete',
  mixins: [
    recordMixin
  ],
  components: {
    AlertArea
  },
  created: function() {
    if (!common.storageAvailable('localStorage')) {
      this.alerts.push(alerts.d01);
      return;
    }
    let storage = window.localStorage;
    let storageStamp = storage.getItem('stamps');
    if(storageStamp) {
      this.stamps = JSON.parse(storageStamp)
          .map(e => ({
            time: e,
            isMarked: false
          }));
    } else {
      this.alerts.push(alerts.p01);
    }

    let preferences = storage.getItem('preferences');
    if(preferences) {
      preferences = JSON.parse(preferences);
      this.preferences['onLoadStamp'] = !!preferences['onLoadStamp'];
      this.preferences['autoReadMore'] = !!preferences['autoReadMore'];
    }
  },
  watch: {
    stampFilters: 'refreshView',
  },
  computed: {
    stampsView: function() {
      let view = this.stamps;
      let from = this.dateFromNorm;
      let to = this.dateToNorm;
      if(from) {
        view = view.filter(d => d.time >= new Date(from.year, from.monthIdx, from.date));
      }
      if(to) {
        view = view.filter(d => d.time <= (new Date(to.year, to.monthIdx, to.date + 1)));
      }
      return view;
    },
  },
  filters: {
    timestamp: function (value) {
      var date = new Date(value);
      return date.toLocaleString();
    }
  },
  methods: {
    deleteStamp: function() {
      let num = this.stamps.filter(s => s.isMarked).length;
      if(confirm(`Are you sure you want to delete ${num} record(s)?`)) {
        this.stamps = this.stamps.filter(s => !s.isMarked);
        this.saveStamps(this.stamps);
      }
    },
    saveStamps: function(newStamps) {
      window.localStorage.setItem('stamps', JSON.stringify(
        newStamps.map(e => e.time)));
    },
    toggleMark: function(obj) {
      obj.isMarked = !obj.isMarked;
    },
    refreshView: function() {
      /*
       * refresh parameters for view of timestamp records
       */
      this.resetLimit();
      this.resetStampMarks();
    },
    resetStampMarks: function() {
      /*
       * turn off marks if records are marked
       */
      this.stamps.filter(s => s.isMarked).forEach(s => s.isMarked = false);
    }
  },
}
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
